import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DelegationService } from 'src/app/shared/services/delegation.service';
import { map } from 'rxjs/operators';
import { Delegation } from 'src/app/shared/models/delegation.model';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { tableSortFn } from 'src/app/shared/utils/sort.util';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employee-delegations',
  templateUrl: './employee-delegations.component.html',
})
export class EmployeeDelegationsComponent implements OnInit {

  delegations$;
  dataSource = new TableDataSource<Delegation>();

  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private serviceDelegation: DelegationService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const employeeId = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    this.delegations$ = this.serviceDelegation.fetchEmployeeDelegations(employeeId)
      .pipe(
        map((delegations: Delegation[]) => {
          this.dataSource.data = delegations;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return delegations;
        })
      );
  }

}
